export default __webpack_public_path__ + "static/media/coin.a06369ee.png";